import React from 'react';
import classNames from 'classnames';

import { Typography } from 'antd';
import { withRouter } from 'react-router';
import styles from './MythicCommanderBanner.module.css';

const MythicCommanderBanner = ({
  fontSize = 20,
  style,
  showCollectionOnClick,
  history,
  hideWhenSmall,
}) => {
  const navigateToCollection = () => history.push('/collection');

  return (
    <div
      className={styles.wrapper}
      style={{ ...style, cursor: showCollectionOnClick && 'pointer' }}
      onClick={showCollectionOnClick && navigateToCollection}
    >
      <img className={styles.icon} src="/favicon.svg" alt="mythic-commander-logo" />
      <span
        className={classNames(styles.textWrapper, {
          [styles.hideWhenSmall]: hideWhenSmall,
        })}
      >
        <Typography.Text style={{ fontSize, color: 'rgba(255, 255, 255, 0.8)' }}>
          Mythic Commander
        </Typography.Text>
      </span>
    </div>
  );
};
export default withRouter(MythicCommanderBanner);
